import { useState, useCallback, useEffect } from "react";
import { instanceAxiosApiFiliado } from "../dataProviders";
import useTempStorage, {
  KEY_COOKIE_CPF_PEDIDO,
  KEY_COOKIE_HASH_PEDIDO,
} from "./useTempStorage";

const useConfirmaIdentidade = () => {
  const [temIdentificacao, setTemIdentificacao] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const { cookie: cpf } = useTempStorage(KEY_COOKIE_CPF_PEDIDO);
  const { cookie: hash } = useTempStorage(
    KEY_COOKIE_HASH_PEDIDO
  );

  useEffect(() => {
    if (!hash && !cpf) {
      setTemIdentificacao(false);
    }
  }, [hash, cpf]);

  const iniciar = useCallback(() => {
    if (!temIdentificacao) return;

    setIsLoading(true);
    instanceAxiosApiFiliado
      .post("/public/confirmar-identidade/iniciar", {
        hashPedido: hash,
        cpf: cpf,
      })
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [cpf, hash, temIdentificacao]);

  const concluir = useCallback(
    async (codigo) => {
      if (!temIdentificacao) return;

      return instanceAxiosApiFiliado
        .post("/public/confirmar-identidade/concluir", {
          hashPedido: hash,
          cpf: cpf,
          codigo: codigo,
        });
    },
    [cpf, hash, temIdentificacao]
  );

  return { isLoading, isError, iniciar, concluir, temIdentificacao };
};

export default useConfirmaIdentidade;
